export default __webpack_public_path__ + "static/media/logo.7d861345.svg";